import React from "react";
import {useTranslation} from "react-i18next";
import "./style.scss";

const TokenCard = ({token, serviceType, storeName, productDetails}) => {
  const {t} = useTranslation();

  return (
    <div className="bg-white rounded-[16px] shadow-md p-6 w-full max-w-[360px] mx-auto text-center space-y-6 h-[90%] font-[Lato,sans-serif]">
      <div className="space-y-2 mt-10">
        <div className="text-[#333333] text-[36px] font-bold leading-[100%] text-center mt-4">
          {t("tokenCardNumber")}
        </div>
        <div className="text-[#333333] text-[120px] font-bold leading-[100%] text-center">
          {token}
        </div>
      </div>
      {productDetails && productDetails.locationsOfProduct?.length > 0 && (
        <div className="bg-[#F0F6FD] text-[#343E49] rounded-[8px] px-4 py-3 text-[18px] leading-[1.4] font-normal">
          {productDetails.backstoreService === "LOCKER" && (
            <>
              {productDetails.locationsOfProduct.length >= 2 ? (
                <>
                  {t("inLocker")}{" "}
                  <span className="font-bold">{t("lockers")}</span>{" "}
                </>
              ) : (
                <>
                  {t("inLockerSingular")}{" "}
                  <span className="font-bold">{t("lockerSingular")}</span>{" "}
                </>
              )}
              {t("youWillFindThe")} {t("restPurchase")}
              .<br />
              <span className="block text-[16px]">
                {t("takeQRcodeMessage")}
              </span>
            </>
          )}
          {productDetails.backstoreService === "CLEVERON" && (
            <>
              {t("in")}{" "}
              <span className="font-bold">
                {productDetails.locationsOfProduct.length > 1
                  ? t("cleveronHeader2Plural") +
                    " " +
                    productDetails.locationsOfProduct.join(" y ") +
                    " "
                  : t("cleveronHeader2Singular") +
                    " " +
                    productDetails.locationsOfProduct[0] +
                    " "}
              </span>
              {t("youWillFindThe")} {t("restPurchase")}.<br />
              <span className="block text-[16px]">
                {t("takeQRcodeMessage")}
              </span>
            </>
          )}
        </div>
      )}
      <hr className="border-t border-[#E6E6E6]" />
      <div className="space-y-4 mt-6">
        <div>
          <div className="text-[#343E49] text-lg font-normal tracking-wide uppercase mt-2">
            {t("selectedService").toUpperCase()}
          </div>
          <div className="text-[#343E49] text-lg font-bold mt-2">
            {serviceType}
          </div>
        </div>
        <hr className="border-t border-[#E6E6E6]" />
        <div>
          <div className="text-[#343E49] text-lg font-normal tracking-wide uppercase mt-2">
            {t("store.label").toUpperCase()}
          </div>
          <div className="text-[#343E49] text-lg font-bold mt-2">
            {storeName}
          </div>
        </div>
        <hr className="border-t border-[#E6E6E6]" />
      </div>
    </div>
  );
};

export default TokenCard;
